// @ts-ignore
import {IApiResponseLanguage} from "../interfaces/apiResponseInterfaces/IApiResponseLanguage.interface";
// @ts-ignore
import {ILanguage} from "../interfaces/ILanguage.interface";

export default class LanguageService
{
    static convertAPIObjects(objects: IApiResponseLanguage[]) {
        return objects.map((obj) => this.convertAPIObject(obj));
    }

    static convertAPIObject(apiObject: IApiResponseLanguage): ILanguage {
        let obj = {
            name: apiObject.name,
            iso: apiObject.iso,
            is_default: !! apiObject.is_default,
            order: apiObject.order,
            iconIso: apiObject.iso,
        } as ILanguage;

        if (apiObject.iso === 'en') {
            obj.iconIso = 'gb';
        }
        return obj;
    }
}